import React, {Component} from "react"
import {Button, Container, Dimmer, Form, Header, Icon, Loader, Message, Segment, Table} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import {
    buildFullName,
    checkIsVerified,
    civilUnionText,
    convertDisplayDateFormatToServer,
    domesticPartnershipText,
    FORGOT_PASSWORD,
    formatMoneyAmount,
    getArrayByLanguage,
    getStepProps,
    getTierName,
    getTranslatedGenderText,
    hasTierSelected,
    isAIG,
    isAnsel,
    isRenaissance,
    resolveErrorMessage,
    spouseText,
    uiFlowStandalone
} from "../utils/common";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import Steps from "./steps/steps";
import axios from "axios";
import moment from "moment";
import Footer from "./footer";
import PaymentDetailsCard from "./paymentDetailsCard/paymentDetailsCard";
import {PaymentDetails} from "./paymentDetailsCard/PaymentDetailsContainer";
import PaymentDetailsWrapper from "./paymentDetailsCard/paymentDetailsWrapper";
import PaymentProcessing from "./paymentDetailsCard/paymentProcessing";
import PaperCheck from "./paperCheck";
import {CardNumberElement, ElementsConsumer} from "@stripe/react-stripe-js";
import {getChronicRiderLabel, getMaternityRiderLabel, getMentalRiderLabel} from "../utils/riders";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {API_URL} from "../utils/config";
import {CustomContainer, CustomDivider, CustomGrid, DOBDisplay, SSNDisplay} from "./custom-common";
import {displayDateFormat} from "../utils/date";
import {PrepareReviewRequest, SubmitPlanInfoRequest} from "../services/types";
import {getPrepareReview, submitPlanInfo} from "../services/services";
import CustomLanguage from "../components/customLanguage"

const SUBMIT_STATUS_SUCCESS = 'SUCCESS';
const SUBMIT_STATUS_ERROR = 'ERROR';
const SUBMIT_STATUS_NOT_FOUND = 'NOT_FOUND';
const DEFAULT_AUTOPAY_GROUP_TYPES = new Set(["Association", "Individual"]);

export const shouldDefaultAutoPayOn = ({initialData, cost}) =>
    isRenaissance() &&
    Boolean(initialData?.isBillingEnabled) &&
    cost > 0 &&
    DEFAULT_AUTOPAY_GROUP_TYPES.has(initialData?.contractInfo?.groupType);

export const resolveSubmitAutoPay = ({isPaymentMethodSelected, autoPay}) =>
    isPaymentMethodSelected ? autoPay : false;

const mapStateToProps = (state, ownProps) => {
    const { user, initialData, benAdmin } = state;

    const contractTerms = initialData?.ratedClass?.contractTerms;
    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;

    return {
        ...ownProps,
        lang: user.lang,
        initialData: initialData,
        user: user, benAdmin,
        token: initialData.token,
        cost: user.cost,
        costPerOptions: initialData.costPerOptions,
        costPerOption: user.costPerOption,
        coverageOptions: initialData.coverageOptions,
        coverageOption: user.coverageOption,
        dependentList: user.dependentList.filter(d => !d.removedFromPlan),
        moderateIncrements: (!!initialData && !!initialData.increments && initialData.increments.moderate) || [],
        severeIncrements: (!!initialData && !!initialData.increments && initialData.increments.severe) || [],
        catastrophicIncrements: (!!initialData && !!initialData.increments && initialData.increments.catastrophic) || [],
        isBrellaChoice: !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice",
        questions: (!!initialData && !!initialData.contractInfo && initialData.contractInfo.questions) || [],
        visibleQuestions: (!!initialData && !!initialData.contractInfo && initialData.contractInfo.questions.filter(q => q && q.show)) || [],
        additionalChronic,
        additionalMental,
        additionalMaternity,
        hasAccount: initialData.hasAccount,
        frauds: initialData.frauds,
        paymentDetails: initialData.paymentDetails,
        dateOfHire: initialData.dateOfHire,
        accountSfId: initialData.contractInfo.accountId,
        effectiveDate: initialData.coverageEffectiveDate,
        riderLabels: initialData.riderLabels,
        tiers: user.selectedTierBrellaSelect,
        issueState: initialData.contractInfo.issueState,
        customLanguage: initialData?.reviewCustomLanguage ?? {},
    }
};

class Review extends Component {
    constructor(props) {
        super(props);
        let initialAnswers = {};
        const {questions} = props;
        questions.forEach((question) => {
            const value = question.defaultValue?.toLowerCase();
            if (value === "yes") {
                initialAnswers[question.developerName] = true;
            } else if (value === "no") {
                initialAnswers[question.developerName] = false;
            } else {
                initialAnswers[question.developerName] = null;
            }
        });

        this.state = {
            stepProps: null,
            submitPlanLoading: false,
            password: '',
            confirmPassword: '',
            agreeToTerms: false,
            invalidPasswordLength: false,
            passwordMissingNumber: false,
            passwordMissingCapital: false,
            passwordsDoNotMatch: false,
            invalidTerms: false,
            creditCardData: null,
            bankAccountData: null,
            autoPay: shouldDefaultAutoPayOn(props),
            paymentDetailsLoading: false,
            stripePaymentError: null,
            isCreditCardFormDisplayed: false,
            microDepositsBankAccountData: null,
            bankAccount: null,
            answers: initialAnswers,
        };
        this.pollTimeout = null;
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
        this.setState({paymentDetailsLoading: true});
        this.prepareReview()
            .then( response => {
                this.setMicroDepositsBankAccountData(response?.microDepositsBankAccount);
                this.setBankAccount(response?.bankAccounts);
                this.setState({paymentDetailsLoading: false});
            }).catch( error => {
            console.error(error)
            this.setState({paymentDetailsLoading: false});
        })
    }

    prepareReview = async () => {
        const {initialData} = this.props
        const {token} = initialData
        try {
            const prepareReviewPayload = new PrepareReviewRequest({token})
            const prepareReviewResponse = await getPrepareReview(prepareReviewPayload)
            return prepareReviewResponse
        } catch (e) {
            console.error(e)
        }
    }

    buildSubmitPlanInfoRequest = ({
        isPaperCheck = false,
        creditCardData = this.state.creditCardData,
        bankAccountData = this.state.bankAccountData,
    } = {}) => {
        const {user, token, initialData, isBrellaChoice, additionalChronic, additionalMental, additionalMaternity,
            costPerOptions, costPerOption, effectiveDate, riderLabels} = this.props;

        const sanitizedDependentList = [];
        if (!!user.dependentList && user.dependentList.length > 0) {
            user.dependentList.filter(d => !d.removedFromPlan).forEach((d) => {
                const copy = {...d}
                copy.birthdate = convertDisplayDateFormatToServer(copy.birthdate);
                sanitizedDependentList.push(copy);
            })
        }

        let moderateCoverageSelected = user.moderateCoverageSelected
        let severeCoverageSelected = user.severeCoverageSelected
        let catastrophicCoverageSelected = user.catastrophicCoverageSelected
        let translatedCoverage = {};
        if (isBrellaChoice) {
            translatedCoverage = this.translateSliderSelectionToAmount();
            moderateCoverageSelected = translatedCoverage.moderateCoverageSelected;
            severeCoverageSelected = translatedCoverage.severeCoverageSelected;
            catastrophicCoverageSelected = translatedCoverage.catastrophicCoverageSelected;
        }

        const costPayment = costPerOptions ? costPerOptions.filter((cpo) => cpo.id === costPerOption)[0].value: null;
        const mEffectiveDate = moment(effectiveDate).format("MMM DD, YYYY");
        const chronicLabel = getChronicRiderLabel(getLocalization(this.props.lang).review, riderLabels);
        const mentalLabel = getMentalRiderLabel(getLocalization(this.props.lang).review, riderLabels);
        const maternityLabel = getMaternityRiderLabel(getLocalization(this.props.lang).review, riderLabels);
        const {microDepositsBankAccountData} = this.state;
        const isPaymentMethodSelected = !!microDepositsBankAccountData || !!creditCardData || !!bankAccountData;
        const paymentMethodStatus = isPaymentMethodSelected && !bankAccountData && !creditCardData && microDepositsBankAccountData
            ? this.getPendingVerificationBankAccountStatus(microDepositsBankAccountData.status)
            : null;

        const request = new SubmitPlanInfoRequest({
            token: token,
            familyTierValue: user.coverageOption,
            moderateBenefit: moderateCoverageSelected,
            severeBenefit: severeCoverageSelected,
            catastrophicBenefit: catastrophicCoverageSelected,
            address: {
                streetAddress: user.streetAddress,
                appartment: user.appartment,
                zipCode: user.zipCode,
                city: user.city,
                state: user.selectedState,
            },
            email: initialData.email,
            firstName: user.firstName,
            lastName: user.lastName,
            middleName: user.middleName,
            suffix: user.suffix,
            phoneNumber: user.daytimePhoneNumber,
            phoneType: user.phoneType,
            familyMembers: sanitizedDependentList,
            password: this.state.password,
            gender: user.gender,
            creditCardData: isPaperCheck ? null : creditCardData,
            bankAccountData: isPaperCheck ? null : bankAccountData,
            amount: '' + this.props.cost,
            autoPay: isPaperCheck ? false : resolveSubmitAutoPay({
                isPaymentMethodSelected,
                autoPay: this.state.autoPay,
            }),
            isBillingEnabled: this.isBillingEnabled(),
            chronicBenefit: additionalChronic,
            chronicTitle: chronicLabel,
            mentalBenefit: additionalMental,
            mentalTitle: mentalLabel,
            maternityBenefit: additionalMaternity,
            maternityTitle: maternityLabel,
            policyEffectiveDate: mEffectiveDate,
            payrollFrequency: costPayment === "Month" ? "mo" : "paycheck",
            paymentMethodStatus: isPaperCheck ? null : paymentMethodStatus,
            ...this.state.answers,
        });
        if (!!this.props.initialData.isPaperEnrollment) {
            request['enrollmentReceivedDate'] = convertDisplayDateFormatToServer(user.enrollmentReceivedDate);
        }
        return request;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.pollTimeout);
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 3, uiFlow, distributionChannel)});
    }

    setStripePaymentError = (stripePaymentError) => {
        this.setState({stripePaymentError});
    }

    setCreditCardData = (data) => {
        this.setState({creditCardData: data})
    }

    setBankAccount = (data) => {
        if(data?.length) {
            this.setState({bankAccount: data[0]})
        }
    }

    setBankAccountData = (data) => {
        this.setState({bankAccountData: data})
    }

    setAutoPayData = (autoPay) => {
        this.setState({autoPay: autoPay})
    }

    setMicroDepositsBankAccountData = (data) => {
        this.setState({microDepositsBankAccountData: data})
    }

    setPaymentDetailsLoading = (value) => {
        this.setState({paymentDetailsLoading: value})
    }

    setIsCreditCardFormDisplayed = (isCreditCardFormDisplayed) => {
        this.setState({isCreditCardFormDisplayed})
    }

    createCreditCardPaymentMethodId = async () =>
        this.props.stripe?.createPaymentMethod({type: 'card', card: this.props.elements.getElement(CardNumberElement)}).then((result) => {
            if (result.error) {
                throw new Error(result.error.message);
            }
            const creditCardData = {paymentMethodId: result.paymentMethod.id};
            this.setCreditCardData(creditCardData);
            return creditCardData;
        });

    checkSubmitPlanInfoStatus = (entryId) => {
        const strings = getLocalization(this.props.lang).review;

        const handleSuccess = () => {
            clearTimeout(this.pollTimeout);
            this.setState({submitPlanLoading: false, error: null});
            window.onbeforeunload = null;
            this.props.history.push(this.props.nextRoute);
        };

        const handleError = (error) => {
            clearTimeout(this.pollTimeout);
            const errMsg = resolveErrorMessage(error, strings.genericError);
            this.setState({submitPlanLoading: false, error: errMsg});
        };

        const poll = async () => {
            const {token} = this.props
            try {
                const {data} = await axios.post(
                    `${API_URL}/checkSubmitPlanInfoStatus`,
                    {entryId, token}
                );
                const {status, error} = data;
                if (status === SUBMIT_STATUS_SUCCESS) {
                    return handleSuccess();
                } else if ([SUBMIT_STATUS_ERROR, SUBMIT_STATUS_NOT_FOUND].includes(status)) {
                    return handleError(error);
                }
            } catch (e) {
                return handleError(e);
            }
            this.pollTimeout = setTimeout(poll, 2000);
        };
        poll();
    };

    submitInitialPlanInfo = async () => {
        const localization = getLocalization(this.props.lang);
        const strings = localization.review;
        const {isCreditCardFormDisplayed} = this.state;
        this.setStripePaymentError(null);
        this.setState({submitPlanLoading: true, error: null});
        try {
            let creditCardData = this.state.creditCardData;
            if (isCreditCardFormDisplayed) {
                creditCardData = await this.createCreditCardPaymentMethodId();
            }
            const request = this.buildSubmitPlanInfoRequest({creditCardData});
			let result = await submitPlanInfo(request);
            if (result.data && result.data.entryId) {
                this.checkSubmitPlanInfoStatus(result.data.entryId);
            } else {
                this.setState({
                    submitPlanLoading: false,
                    error: strings.genericError,
                });
            }
        } catch (e) {
            const stripePaymentError = e?.response?.data?.paymentErrorMsg;
            if (stripePaymentError) {
                this.setStripePaymentError(stripePaymentError);
            } else {
                this.setState({error: strings.genericError});
            }
            this.setState({submitPlanLoading: false});
        }
    }

    submitPlanInfoWithPaperCheck = async () => {
        const strings = getLocalization(this.props.lang).review;
        this.setStripePaymentError(null);
        this.setState({submitPlanLoading: true, error: null});
        try {
            const request = this.buildSubmitPlanInfoRequest({isPaperCheck: true});
            const result = await submitPlanInfo(request);
            if (result.data && result.data.entryId) {
                this.checkSubmitPlanInfoStatus(result.data.entryId);
            } else {
                this.setState({
                    submitPlanLoading: false,
                    error: strings.genericError,
                });
            }
        } catch (e) {
            const stripePaymentError = e?.response?.data?.paymentErrorMsg;
            if (stripePaymentError) {
                this.setStripePaymentError(stripePaymentError);
            } else {
                this.setState({error: strings.genericError});
            }
            this.setState({submitPlanLoading: false});
        }
    }

    handleChange = (_, {value, name, type, checked}) => {
        const newValue = type === 'checkbox' ? checked : value;
        if (name === 'agreeToTerms'){
            this.setState({
                [name]: newValue,
                invalidTerms: false
            }, () => {
                    this.validateTerms()
            })
        } else {
            this.setState({
                [name]: newValue,
                invalidPasswordLength: false,
                passwordMissingNumber: false,
                passwordMissingCapital: false,
                passwordsDoNotMatch: false,
            }, () => {
                if(!this.validatePassword()) {
                    this.validatePasswordMatch()
                }
            })
        }
    }

    handleEditButton = (path) => {
        this.props.history.push(path);
    }

    translateSliderSelectionToAmount = () => {
        const {
            moderateIncrements,
            severeIncrements,
            catastrophicIncrements,
            user: {moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected}
        } = this.props;
        return {
            moderateCoverageSelected: moderateIncrements[moderateCoverageSelected - 1],
            severeCoverageSelected: severeIncrements[severeCoverageSelected - 1],
            catastrophicCoverageSelected: catastrophicIncrements[catastrophicCoverageSelected - 1],
        }
    }

    validatePassword = () => {
        const {password} = this.state;
        const hasNumberExp = /\d/;
        const invalidPasswordLength = password.length < 10
        const passwordMissingNumber = !invalidPasswordLength && !hasNumberExp.test(password);
        const passwordMissingCapital = !invalidPasswordLength && !passwordMissingNumber && password.toLowerCase() === password;
        if (invalidPasswordLength || passwordMissingNumber || passwordMissingCapital) {
            this.setState({
                invalidPasswordLength: invalidPasswordLength,
                passwordMissingNumber: passwordMissingNumber,
                passwordMissingCapital: passwordMissingCapital
            })
        }
        return invalidPasswordLength || passwordMissingNumber || passwordMissingCapital;
    }

    validatePasswordMatch = () => {
        const {confirmPassword, password} = this.state;
        if (password !== confirmPassword) {
            this.setState({
                passwordsDoNotMatch: true
            })
        }
    }

    validateTerms = () => {
        const {agreeToTerms} = this.state;
        if (!agreeToTerms) {
            this.setState({
                invalidTerms: true
            })
        }
    }

    isBillingEnabled () {
        const {initialData, cost} = this.props
        return Boolean(initialData?.isBillingEnabled) && cost > 0
    }

    getPaymentMethodStatus () {
        const {microDepositsBankAccountData, creditCardData, bankAccountData} = this.state
        if(!this.isPaymentMethodSelected()) {
            return null
        }else if(bankAccountData || creditCardData){
            return null
        }else if(microDepositsBankAccountData){
            return this.getPendingVerificationBankAccountStatus(microDepositsBankAccountData.status)
        }
    }

    isPaymentMethodSelected () {
        const {microDepositsBankAccountData, creditCardData, bankAccountData} = this.state
        return !!microDepositsBankAccountData || !!creditCardData || !!bankAccountData
    }

    getPendingVerificationBankAccountStatus(status) {
        switch (status) {
            case "manually_verified":
                return "Verified"
            case "pending_manual_verification":
                return "Pending verification"
            case "verification_failed":
                return "Failed verification"
            default:
                return status
        }
    }

    CardContainer = ({children, ...props}) => (
        <CustomContainer padded {...props}>
            <CustomContainer basic className="moderate padded">
                {children}
            </CustomContainer>
        </CustomContainer>
    );

    handleQuestionChange = (key, value) => {
        this.setState(prevState => ({
            answers: {
                ...prevState.answers,
                [key]: value
            }
        }))
    };


    resolveQuestion = (developerName, backendLabel, localizationRoot, issueState) => {
        const normalizeKeyPart = (s) => String(s || "").replace(/[^A-Za-z0-9]/g, "");

        const baseKey = String(developerName || "").trim();
        const stateSuffix = normalizeKeyPart(issueState);
        const stateSpecificCopyKey = stateSuffix ? `${baseKey}${stateSuffix}` : null;

        if (stateSpecificCopyKey && stateSpecificCopyKey in localizationRoot) {
            return localizationRoot[stateSpecificCopyKey];
        }

        if (baseKey in localizationRoot) {
            return localizationRoot[baseKey];
        }

        return null;
    };

    renderQuestions = () => {
        const {visibleQuestions, lang} = this.props;
        const localizationRoot = getLocalization(lang);
        const reviewStrings = localizationRoot.review;

        if (!visibleQuestions?.length) return null;

        const items = visibleQuestions.map((question) => {
            if (!question?.developerName) return null;

            const resolved = this.resolveQuestion(
                question.developerName,
                question.label,
                localizationRoot,
                this.props.issueState
            );

            if (!resolved) return null;

            const {message, question: questionText, questionNote, belowOptionsText} = resolved;

            return (
                <React.Fragment key={question.developerName}>
                    <CustomDivider hidden />
                    <CustomGrid padded>
                        <CustomGrid.Row>
                            <CustomGrid.Column>
                                {!!message && <p className="neutral700Text">{parseMultilineString(message)}</p>}
                                {!!questionText && <p>
                                    <b>{questionText}</b>
                                    {!!questionNote && <><br />{questionNote}</>}
                                </p>}
                                <Form.Group grouped>
                                    <Form.Radio
                                        label={reviewStrings.yes}
                                        value="yes"
                                        name={question.developerName}
                                        checked={this.state.answers[question.developerName] === true}
                                        onChange={() => this.handleQuestionChange(question.developerName, true)}
                                    />
                                    <Form.Radio
                                        label={reviewStrings.no}
                                        value="no"
                                        name={question.developerName}
                                        checked={this.state.answers[question.developerName] === false}
                                        onChange={() => this.handleQuestionChange(question.developerName, false)}
                                    />
                                </Form.Group>
                                <CustomDivider small hidden/>
                                {!!belowOptionsText && <div className="neutral700Text" dangerouslySetInnerHTML={{ __html: belowOptionsText }} />}
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    </CustomGrid>
                </React.Fragment>
            );
        })

        return items.some(Boolean)
            ? <this.CardContainer>{items.filter(Boolean)}</this.CardContainer>
            : null;
    };

    isMarylandEmployer = () => {
        const {initialData} = this.props;
        return initialData?.employer?.address?.state === "MD";
    };

    render() {
        const {
            stepProps,
            password,
            confirmPassword,
            agreeToTerms,
            submitPlanLoading,
            invalidPasswordLength,
            passwordMissingNumber,
            passwordMissingCapital,
            passwordsDoNotMatch,
            invalidTerms,
            paymentDetailsLoading,
        } = this.state;
        const {
            visibleQuestions,
        } = this.props

        const allQuestionsAnswered = visibleQuestions.every(q => this.state.answers[q.developerName] !== null);

        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const {
            lang,
            cost,
            costPerOptions,
            costPerOption,
            coverageOptions,
            coverageOption,
            dependentList,
            isBrellaChoice,
            user,
            additionalChronic,
            additionalMental,
            additionalMaternity,
            hasAccount,
            frauds,
            paymentDetails,
            initialData,
            accountSfId,
            effectiveDate,
            riderLabels,
            tiers,
            customLanguage,
        } = this.props;
        const localization = getLocalization(lang);
        const strings = localization.review;

        const {
            attestationDisclaimer: customLanguageAttestationDisclaimer = null,
            misrepresentationWarning: customLanguageMisrepresentationWarning = null,
            medicareWarning: customLanguageMedicareWarning = null,
            notSubstituteDisclaimer: customLanguageNotSubstituteDisclaimer = null,
            notSubstituteWarning: customLanguageNotSubstituteWarning = null,
            generic: customLanguageGeneric = null,
            consentNotice: customLanguageConsentNotice = null,
            minimumCoverageWarning: customLanguageMinimumCoverageWarning = null,
            limitedBenefitsWarning: customLanguageLimitedBenefitsWarning = null,
        } = customLanguage?.[lang] ?? {};

        let selectedStateStr = this.props.initialData.stateOptions.filter((s) => s.value === this.props.user.selectedState);
        if (selectedStateStr.length > 0) {
            try {
                selectedStateStr = selectedStateStr[0].text;
            } catch (e) {
                console.error(e);
                selectedStateStr = "";
            }
        }

        let moderateCoverageSelected = user.moderateCoverageSelected
        let severeCoverageSelected = user.severeCoverageSelected
        let catastrophicCoverageSelected = user.catastrophicCoverageSelected
        let translatedCoverage = {};
        if (isBrellaChoice) {
            translatedCoverage = this.translateSliderSelectionToAmount();
            moderateCoverageSelected = translatedCoverage.moderateCoverageSelected;
            severeCoverageSelected = translatedCoverage.severeCoverageSelected;
            catastrophicCoverageSelected = translatedCoverage.catastrophicCoverageSelected;
        }

        const selectedCoverageOption = coverageOptions.filter((co) => co.value === coverageOption);

        const spouse = dependentList.filter((dependent) => dependent.relationship === spouseText)[0];
        const domesticPartner = dependentList.filter((dependent) => dependent.relationship === domesticPartnershipText)[0];
        const civilUnion = dependentList.filter((dependent) => dependent.relationship === civilUnionText)[0];
        const children = dependentList.filter((dependent) => dependent.relationship === "Child");

        const editAdditionalInfo = <Button primary basic icon className={'spaceNoWrap'}
                                           style={{paddingBottom: '8px', paddingTop: '8px'}}
                                           onClick={() => this.handleEditButton("/additionalInfo")}><b>{strings.edit}</b> {' '}
            <Icon className={'buttonIcon'} name={'pencil'}/>
        </Button>
        const editBenefitAmounts = <Button primary basic icon className={'spaceNoWrap'}
                                           style={{paddingBottom: '8px', paddingTop: '8px'}}
                                           onClick={() => this.handleEditButton("/plan")}><b>{strings.edit}</b> {' '}
            <Icon
                className={'buttonIcon'} name={'pencil'}/>
        </Button>

        let hideDependents = false;
        let dependentsTableBody;
        if (!!selectedCoverageOption && selectedCoverageOption.length > 0) {
            const selectedCoverageCode = selectedCoverageOption[0].value;
            if (selectedCoverageCode === 'employee' || (!spouse && !domesticPartner && !civilUnion && (!children || children.length === 0))) {
                hideDependents = true;
                dependentsTableBody = <div/>;
            } else {
                dependentsTableBody = <React.Fragment><Table basic={'very'}
                                                             style={{marginTop: '.1em', maxWidth: '50em'}}><Table.Body>
                    {!!spouse && <Table.Row>
                        <Table.Cell>
                            <DOBDisplay label={strings.spouse} name={buildFullName({firstName: spouse.firstName, lastName: spouse.lastName})} isVerticalLayout
                                        dob={moment(spouse.birthdate).format(displayDateFormat)} visibilityIconVisible={true}/>
                        </Table.Cell>
                    </Table.Row>
                    }
                    {!!domesticPartner &&
                        <Table.Row>
                            <Table.Cell>
                                <DOBDisplay label={strings.domesticPartner} name={buildFullName({firstName: domesticPartner.firstName, lastName: domesticPartner.lastName})}
                                            isVerticalLayout dob={moment(domesticPartner.birthdate).format(displayDateFormat)} visibilityIconVisible={true}/>
                            </Table.Cell>
                        </Table.Row>}
                    {!!civilUnion &&
                        <Table.Row>
                            <Table.Cell>
                                <DOBDisplay label={strings.civilUnion} name={buildFullName({firstName: civilUnion.firstName, lastName: civilUnion.lastName})}
                                            isVerticalLayout dob={moment(civilUnion.birthdate).format(displayDateFormat)} visibilityIconVisible={true}/>
                            </Table.Cell>
                        </Table.Row>}
                    {!!children && children.length > 0 && children.map((cd, idx) => {
                        return <Table.Row>
                            <Table.Cell>
                                <DOBDisplay key={idx} label={strings.child} name={buildFullName({firstName: cd.firstName, lastName: cd.lastName})} isVerticalLayout
                                            dob={moment(cd.birthdate).format(displayDateFormat)} visibilityIconVisible={true}/>
                            </Table.Cell>
                        </Table.Row>
                    })}
                    <Table.Row>
                    </Table.Row>
                </Table.Body>
                </Table>
                    {editAdditionalInfo}
                </React.Fragment>
            }
        }

        const costPayment = costPerOptions ? costPerOptions.filter((cpo) => cpo.id === costPerOption)[0].value: null;
        const formattedCostPayment = costPayment === "Month" ? strings.mo : strings.paycheck.toLowerCase();
        const employerContributionCoversTotalAmmount = cost === 0;

        let attestationDisclaimerRaw = strings.disclaimer3
        let disclaimer3Opt1 = strings.disclaimer3Opt1
        let disclaimer3Opt2 = strings.disclaimer3Opt2
        let disclaimer3Opt3 = strings.disclaimer3Opt3
        let disclaimer3Opt2b = strings.disclaimer3Opt2b

        if (customLanguageAttestationDisclaimer) {
            attestationDisclaimerRaw = customLanguageAttestationDisclaimer.attestationDisclaimer
            disclaimer3Opt1 = customLanguageAttestationDisclaimer.conditionalValues?.andMembers
            disclaimer3Opt2 = customLanguageAttestationDisclaimer.conditionalValues?.authorizingPremiumDeduction
            disclaimer3Opt3 = customLanguageAttestationDisclaimer.conditionalValues?.acceptingCoverageAtNoCost
        }

        let disclaimer3FirstConditional = disclaimer3Opt1 + " ";
        if (!!selectedCoverageOption && selectedCoverageOption.length > 0 && selectedCoverageOption[0].value === "employee") {
            disclaimer3FirstConditional = "";
        }

        let disclaimer3SecondConditional = disclaimer3Opt2;
        if (isAIG()) {
            if (["Indiana", "IN"].includes(initialData.employer.address?.state)) {
                disclaimer3SecondConditional = disclaimer3Opt3;
            }
        } else {
            if (this.isBillingEnabled()) {
                disclaimer3SecondConditional = customLanguageAttestationDisclaimer
                    ? disclaimer3Opt2
                    : disclaimer3Opt2b;
            } else {
                if (employerContributionCoversTotalAmmount) {
                    disclaimer3SecondConditional = disclaimer3Opt3;
                }
            }
        }
        const disclaimer3 = interpolateString(attestationDisclaimerRaw, [disclaimer3FirstConditional, disclaimer3SecondConditional]);

        const isConciergePreview = !!this.props.initialData.isConcierge && !!this.props.initialData.notSaveUserProgress;
        const fraudList = getArrayByLanguage(frauds, lang);

        const riders = [
            { value: additionalChronic, label: getChronicRiderLabel(strings, riderLabels) },
            { value: additionalMental, label: getMentalRiderLabel(strings, riderLabels) },
            { value: additionalMaternity, label: getMaternityRiderLabel(strings, riderLabels) },
        ].filter(({ value }) => value > 0);

        const {uiFlow} = initialData;
        const isStandalone = uiFlow === uiFlowStandalone;
        const useGroupTypeAutoPayFlow = shouldDefaultAutoPayOn(this.props);

        return (
            <PaymentDetails.Provider initialState={{
                setCreditCardData: this.setCreditCardData,
                setBankAccountData: this.setBankAccountData,
                setMicroDepositsBankAccountData: this.setMicroDepositsBankAccountData,
                setAutoPayData: this.setAutoPayData,
                setPaymentDetailsLoading: this.setPaymentDetailsLoading,
                stripePaymentError: this.state.stripePaymentError,
                setStripePaymentError: this.setStripePaymentError,
                setIsCreditCardFormDisplayed: this.setIsCreditCardFormDisplayed,
                getBillingInfo: this.getBillingInfo,
                initialAutoPay: this.state.autoPay,
                useGroupTypeAutoPayFlow,
                bankAccount: this.state.bankAccount,
                microDepositsBankAccount: this.state.microDepositsBankAccountData,
            }}>
                <Container className={'contentContainer reviewContent'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={10}>
                            <this.CardContainer>
                                <CustomGrid stackable container>
                                    <CustomGrid.Row columns={1}>
                                        <CustomGrid.Column textAlign={'left'}>
                                            <Header as='h2'>{strings.title}</Header>
                                            <b>{strings.beforeFinal}</b>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>
                                    <CustomGrid.Row columns={2}>
                                        <CustomGrid.Column style={{overflowWrap: 'anywhere'}} className={"small"}>
                                            <p className="small neutral600Text">
                                                <b>{strings.personalDetails}</b>
                                            </p>
                                            <p className={'spaceNoWrap'}>
                                                <b>{strings.firstName}</b><br/>{this.props.user.firstName}</p>
                                            <p className={'spaceNoWrap'}>
                                                <b>{strings.middleName}</b><br/>{this.props.user.middleName}</p>
                                            <p className={'spaceNoWrap'}>
                                                <b>{strings.lastName}</b><br/>{this.props.user.lastName}</p>
                                            <p><b>{strings.email}</b><br/>{this.props.initialData.email}</p>
                                            <p>
                                                <DOBDisplay label={strings.birthdate} dob={moment(this.props.user.birthdate).format(displayDateFormat)} visibilityIconVisible={true}/>
                                            </p>
                                            <p>
                                                <b>{strings.gender}</b><br/>{getTranslatedGenderText(this.props.user.gender, localization)}
                                            </p>
                                            <p>
                                                <SSNDisplay label={strings.ssn} ssn={this.props.user.ssn} visibilityIconVisible={true}/>
                                            </p>
                                            <p>
                                                <b>{strings.address}</b><br/>{this.props.user.streetAddress}{!!this.props.user.appartment ? ', ' + this.props.user.appartment : null}
                                            </p>
                                            <p><b>{strings.city}</b><br/>{this.props.user.city}</p>
                                            <p><b>{strings.state}</b><br/>{selectedStateStr}</p>
                                            <p><b>{strings.zipCode}</b><br/>{this.props.user.zipCode}</p>
                                            {editAdditionalInfo}
                                        </CustomGrid.Column>

                                        <CustomGrid.Column className={"small"}>
                                            <CustomGrid.Row>
                                                {(isAIG() || isRenaissance()) && isStandalone && hasTierSelected(tiers) &&
                                                <React.Fragment>
                                                    <div className="small neutral600Text">
                                                        <b>{strings.selectOffering}</b>
                                                    </div>
                                                    <Table basic={'very'} className="summaryTableMarginTop">
                                                        <Table.Body>
                                                            <Table.Row>
                                                                <Table.Cell><b>{strings.planName}</b></Table.Cell>
                                                                <Table.Cell textAlign={'right'}>{getTierName(tiers)}</Table.Cell>
                                                            </Table.Row>
                                                        </Table.Body>
                                                    </Table>
                                                </React.Fragment>
                                                }
                                                <div className="small neutral600Text">
                                                    <b>{strings.benefitAmounts}</b>
                                                </div>
                                                <Table basic={'very'} style={{marginTop: '.1em'}}>
                                                    <Table.Body>
                                                        <Table.Row>
                                                            <Table.Cell><b>{strings.moderate}</b></Table.Cell>
                                                            <Table.Cell
                                                                textAlign={'right'}>${formatMoneyAmount(moderateCoverageSelected)}</Table.Cell>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.Cell><b>{strings.severe}</b></Table.Cell>
                                                            <Table.Cell
                                                                textAlign={'right'}>${formatMoneyAmount(severeCoverageSelected)}</Table.Cell>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.Cell><b>{strings.catastrophic}</b></Table.Cell>
                                                            <Table.Cell
                                                                textAlign={'right'}>${formatMoneyAmount(catastrophicCoverageSelected)}</Table.Cell>
                                                        </Table.Row>
                                                    </Table.Body>
                                                </Table>
                                                {editBenefitAmounts}
                                            </CustomGrid.Row>

                                            {riders.length > 0 && (
                                                <CustomGrid.Row style={{ marginTop: '2em' }}>
                                                    <div className="small neutral600Text">
                                                        <b>{strings.additionalCoverage}</b>
                                                    </div>
                                                    <Table basic="very" style={{ marginTop: '.1em' }}>
                                                        <Table.Body>
                                                            {riders.map(({ value, label }, idx) => (
                                                                <Table.Row key={idx}>
                                                                    <Table.Cell><b>{label}</b></Table.Cell>
                                                                    <Table.Cell textAlign="right">${value}</Table.Cell>
                                                                </Table.Row>
                                                            ))}
                                                        </Table.Body>
                                                    </Table>
                                                    {editBenefitAmounts}
                                                </CustomGrid.Row>
                                            )}

                                            {!hideDependents && <CustomGrid.Row style={{marginTop: '2em'}}>
                                                <div className="small neutral600Text">
                                                    <b>{strings.dependents}</b>
                                                </div>
                                                {dependentsTableBody}
                                            </CustomGrid.Row>}

                                            <CustomGrid.Row style={{marginTop: '2em'}}>
                                                {this.isBillingEnabled()
                                                    ? (
                                                        <Segment basic className={"bkgLinen"} compact>
                                                            <b className={"small neutral600Text"}>{strings.effectiveDate}</b>
                                                            <Header as={"h4"} className={'neutral900Text'} content={moment(effectiveDate).format("MMM DD, YYYY")} />
                                                            <p style={{ fontSize: '14px' }} ><b>{strings.note}</b> <em>{strings.yourBrellaCoverage}</em></p>
                                                        </Segment>
                                                    )
                                                    : (
                                                        <>
                                                            <Segment basic className={"reviewYourCostBkg"} compact>
                                                                {!!user.employerContribution && <React.Fragment>
                                                                    <div className="smaller neutral600Text">
                                                                        {strings.employerContribution}
                                                                    </div>
                                                                    <div className={"primaryBoldColor"}>
                                                                        <b>${user.employerContribution}/{formattedCostPayment}</b>
                                                                    </div>
                                                                    <br/>
                                                                </React.Fragment>
                                                                }
                                                                <div className="smaller neutral600Text">{strings.yourCost}</div>
                                                                <Header as={"h4"}
                                                                        style={{margin: 0}}><b>${cost}</b>/{formattedCostPayment}
                                                                </Header>
                                                            </Segment>
                                                            <p className="small neutral600Text">
                                                                <b>{strings.effectiveDate}</b><br/>{moment(effectiveDate).format("MMM DD, YYYY")}
                                                            </p>
                                                        </>
                                                    )
                                                }
                                            </CustomGrid.Row>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>
                                </CustomGrid>
                            </this.CardContainer>
                            {this.renderQuestions()}
                            {paymentDetailsLoading && <Dimmer active page><Loader/></Dimmer>}
                            <PaperCheck strings={strings} loading={paymentDetailsLoading}
                                        onSubmit={this.submitPlanInfoWithPaperCheck}/>
                            {this.isBillingEnabled() && !this.props.initialData.isConcierge &&
                                <>
                                    <this.CardContainer>
                                        <CustomDivider hidden/>
                                        <PaymentDetailsCard
                                            plaidEnviroment={paymentDetails.plaidEnvironment}
                                            plaidLinkToken={paymentDetails.plaidLinkToken}
                                            stripePublicKey={paymentDetails.stripePublicKey}
                                            user={{...user, email: initialData.email}}
                                            formattedCostPayment={formattedCostPayment}
                                            token={initialData.token}
                                            paymentDetails={initialData.paymentDetails}
                                            accountSfId={accountSfId}
                                            strings={strings}
                                            microDepositsBankAccount={this.state.microDepositsBankAccountData}
                                        />
                                    </this.CardContainer>
                                </>
                            }
                            {!this.props.initialData.isPaperEnrollment &&
                                !this.props.initialData.isConcierge &&
                                <>
                                    <CustomDivider hidden/>
                                    <this.CardContainer>
                                        <CustomGrid columns={1} container>
                                            <CustomGrid.Row>
                                                <CustomGrid.Column>
                                                    <Header as="h4">{strings.createAccount}</Header>
                                                    <div className={"small neutral700Text"}>
                                                        {hasAccount ? strings.looksLikeWeAlready : strings.createAccountDescr}
                                                        <br/>

                                                        {hasAccount ? strings.thisMayBe : strings.passwordsMust}
                                                        <br/>

                                                        {!hasAccount && <ul style={{paddingLeft: '1em'}}>
                                                            <li>{strings.p1}</li>
                                                            <li>{strings.p2}</li>
                                                            <li>{strings.p3}</li>
                                                        </ul>}
                                                    </div>

                                                    <Form style={{marginTop: '1.5em'}}>
                                                        {!hasAccount &&
                                                            <Form.Group width={"equal"}>
                                                                <Form.Field error={!!invalidPasswordLength || !!passwordMissingNumber || !!passwordMissingCapital}>
                                                                    <Form.Input label={strings.enterPassword}
                                                                                value={password}
                                                                                required
                                                                                onChange={this.handleChange} name="password"
                                                                                onBlur={this.validatePassword}
                                                                                type={"password"}/>
                                                                    {invalidPasswordLength &&
                                                                        <small className={'errorText'}>{strings.pErr1}</small>}
                                                                    {passwordMissingNumber &&
                                                                        <small className={'errorText'}>{strings.pErr2}</small>}
                                                                    {passwordMissingCapital &&
                                                                        <small className={'errorText'}>{strings.pErr3}</small>}
                                                                </Form.Field>
                                                                <Form.Field error={!!passwordsDoNotMatch}>
                                                                    <Form.Input label={strings.enterPasswordAgain}
                                                                                name="confirmPassword"
                                                                                value={confirmPassword}
                                                                                required
                                                                                onBlur={this.validatePasswordMatch}
                                                                                onChange={this.handleChange} type="password"
                                                                    />
                                                                    {passwordsDoNotMatch &&
                                                                        <small className={'errorText'}>{strings.pErr4}</small>}
                                                                </Form.Field>
                                                            </Form.Group>}

                                                        <Form.Field>
                                                            <Form.Checkbox
                                                                name="agreeToTerms"
                                                                checked={agreeToTerms}
                                                                onChange={this.handleChange}
                                                                label={<label>{strings.iAcceptThe} <a
                                                                    href={STRATEGIC_PARTNER.LEGAL.TERMS} target="_blank"
                                                                    rel="noopener noreferrer">{strings.terms}</a> {strings.and} <a
                                                                    href={STRATEGIC_PARTNER.LEGAL.PRIVACY}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer">{strings.privacy}</a></label>}
                                                                    />
                                                            {!!invalidTerms && (
                                                                <small className={'errorText'}>
                                                                    {strings.pErr5}
                                                                </small>
                                                            )}
                                                        </Form.Field>

                                                        {hasAccount && <React.Fragment>
                                                            <Form.Field>
                                                                <Form.Input label={strings.enterPassword} value={password}
                                                                            required
                                                                            onChange={this.handleChange} name="password"
                                                                            type={"password"}/>
                                                            </Form.Field>

                                                            <Link className="linkText" onClick={() => {
                                                                window.onbeforeunload = null;
                                                            }} to={`${FORGOT_PASSWORD}`}>Forgot Password?</Link>
                                                        </React.Fragment>
                                                        }
                                                    </Form>

                                                    <CustomDivider hidden/>
                                                    <p className={"smaller neutral700Text"}>{strings.fraudWarning}</p>
                                                    {fraudList.map(i => <p className={"smaller neutral700Text"}>{i.title}</p>)}
                                                    {customLanguageNotSubstituteDisclaimer
                                                        ? <CustomLanguage strings={customLanguageNotSubstituteDisclaimer}/>
                                                        : <p className={"smaller neutral700Text"}>{isAIG() ? parseMultilineString(strings.disclaimer2) : strings.disclaimer2}</p>}
                                                    {isAIG() && this.isMarylandEmployer() && strings.disclaimerExtraMD && (
                                                        <p className={"neutral700Text"} style={{fontSize: "14px"}}>{parseMultilineString(strings.disclaimerExtraMD)}</p>
                                                    )}
                                                    <CustomLanguage strings={customLanguageMedicareWarning}/>
                                                    {isAnsel() && <p className="smaller neutral700Text">{strings.limitedBenefitsReviewNotice}</p>}
                                                    <CustomLanguage strings={customLanguageMinimumCoverageWarning}/>
                                                    <CustomLanguage strings={customLanguageMisrepresentationWarning}/>
                                                    <CustomLanguage strings={customLanguageNotSubstituteWarning}/>
                                                    <p className={"smaller neutral700Text"}>{isAIG() ? parseMultilineString(disclaimer3) : disclaimer3}</p>
                                                    <CustomLanguage strings={customLanguageLimitedBenefitsWarning}/>
                                                    <CustomLanguage strings={customLanguageConsentNotice}/>
                                                    <CustomLanguage strings={customLanguageGeneric}/>
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                        </CustomGrid>
                                    </this.CardContainer>
                                </>
                            }
                            {!!this.state.error && <Message negative>{this.state.error}</Message>}
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <PaymentDetailsWrapper>
                    {({isPmSelected, showPaperCheckConfirmation, isCreditCardSetted}) => {
                        const onClickCallback = () => {
                            isPmSelected || !this.isBillingEnabled() ? this.submitInitialPlanInfo() : showPaperCheckConfirmation();
                        };

                        return (<>
                                <PaymentProcessing
                                    loading={this.isBillingEnabled() && submitPlanLoading}
                                    isElectronicPayment={isPmSelected}
                                    strings={strings}
                                />
                                <Footer
                                    loading={submitPlanLoading}
                                    showTopFooter={true} showCenterData={true}
                                    disabled={
                                        (paymentDetailsLoading || !this.props.initialData.isPaperEnrollment) && !this.props.initialData.isConcierge && (!password ||
                                            (!hasAccount && (!confirmPassword || password !== confirmPassword)) ||
                                            isConciergePreview ||
                                            !!invalidPasswordLength ||
                                            !!passwordMissingNumber ||
                                            !!passwordMissingCapital ||
                                            !agreeToTerms ||
                                            (this.state.isCreditCardFormDisplayed && !isCreditCardSetted) ||
                                            !allQuestionsAnswered
                                        )}
                                    buttonText={strings.nextButton}
                                    onClickCallback={onClickCallback}
                                />
                            </>
                        )
                    }}
                </PaymentDetailsWrapper>
            </PaymentDetails.Provider>
        )
    }
}

const ConnectedReview = withRouter(connect(mapStateToProps)(Review));

const ReviewWithStripe = (props) => (
    <ElementsConsumer>
        {({stripe, elements}) => <ConnectedReview {...props} stripe={stripe} elements={elements} />}
    </ElementsConsumer>
);

export default ReviewWithStripe;
